module.exports = __webpack_public_path__ + "static/media/events-img.43bd6c7b.png";